import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { RESPONSE_STATUS } from '../../../core/constants/enums';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root'
  })
export class ToastService {
  responseStatusEnum = RESPONSE_STATUS;
  constructor(
    private toastController: ToastController,
    private translateService: TranslateService
  ) {}

  async showToast(message: string, type: RESPONSE_STATUS, position?: 'top' | 'bottom' | 'middle') {

    const toast = await this.toastController.create({
      message,
      duration: 5500,
      color: type,
      position
    });
    await toast.present();
  }
  async showToastWithTranslation(message: string, type: RESPONSE_STATUS) {

    const toast = await this.toastController.create({
      message: this.getTranslation(message),
      duration: 5500,
      color: type
    });
    await toast.present();
  }

  public getTranslation(translate: any): string {
    let response = JSON.stringify(translate);
    if (!!translate) {
      if (typeof translate === 'string') {
        this.translateService.get(translate).subscribe((value) => {
          if (!!value) {
            response = value;
          }
        });
      } else if (translate.key && translate.interpolateParams) {
        this.translateService.get(translate.key, translate.interpolateParams).subscribe((value) => {
          if (!!value) {
            response = value;
          }
        });
      }
    }

    return response;
  }
}
